import { BasicService } from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_MODULE_URL } from '../../connection.data';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class ModuleService extends BasicService {

    private currentModule: any = null;
    moduleLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    moduleList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
    moduleList: any[];

    constructor(http: HttpClient) {
        super(http);
        this.baseUrl = API_MODULE_URL;
    }

    getAll(): Observable<any[]> {
        return super.getAll().pipe(tap(moduleList=>{
            this.moduleList$.next(moduleList);
            this.moduleList = moduleList;
        }));
    }

    getAllInExistence(): Observable<any[]> {
        return this.http.get<any>(API_MODULE_URL + '/existence').pipe(
            map((resp) => resp.rows)
        );
    }

    mapToModuleList(moduleList) {
        var unique = (myArray) => myArray.filter((v, i, a) => a.indexOf(v) === i);

        //console.log("module list fetched from api: "); console.dir(moduleList);
        var moduleList_ = [];
        var processedIdList = [];
        //var treeData = {};
        moduleList.forEach(module_ => {
            const moduleId = module_.id;
            if (processedIdList.includes(moduleId)) return;
            processedIdList.push(moduleId);
            const rows = moduleList.filter(module_ => module_.id == moduleId);
            // console.log("rows"); console.dir(rows);
            const subModuleIds = rows.filter(row => row.sub_module_id != null).map(row => row.sub_module_id);
            const uniqueSubModuleIds = unique(subModuleIds);

            // console.log("sub modules ids: "); console.dir(subModuleIds);
            // console.log("unique sub modules ids: "); console.dir(uniqueSubModuleIds);


            var moduleItem = {
                id: module_.id,
                name: module_.name,
                title: module_.name,
                root: true,
                toggle: 'click',
                page: module_.page,
                description: module_.description,
                is_ir4hub: module_.is_ir4hub,
                icon_path: module_.icon_path,
                groups: rows.map(module_ => module_.group_id)
            };

            //treeData[`${module_.name}`] = null;


            uniqueSubModuleIds.forEach(subModuleId => {
                const subModule = rows.find(row => row.sub_module_id == subModuleId);
                if (moduleItem['submenu'] == undefined) {
                    moduleItem['submenu'] = [];
                    //treeData[`${module_.name}`] = {};
                };
                // console.log("submenu: "); console.dir(subModule);
                var subNode = {};
                var subModuleItem = {
                    id: parseInt(subModule.module_id)*100+parseInt(subModule.sub_module_id),
                    name: subModule.sub_module_name,
                    title: subModule.sub_module_name,
                    page: subModule.sub_module_page,
                    description: subModule.sub_module_description,
                    is_ir4hub: subModule.sub_module_is_ir4hub,
                    pos: subModule.sub_module_pos,
                    icon_path: subModule.sub_module_icon_path,
                    groups: rows.filter(module_ => module_.sub_module_id == subModuleId).map(module_ => module_.group_id)
                };

                const subSubModuleList = unique(rows.
                    filter(row => row.sub_module_id == subModuleId).
                    map(row => row.sub_sub_module_id)
                )
                    .map(id => rows.find(row => row.sub_sub_module_id == id))
                    .filter(row => row.sub_sub_module_id != null).map(item => {
                        return {
                            id: parseInt(item.module_id)*100+parseInt(item.sub_module_id)*10+parseInt(item.sub_sub_module_id),
                            name: item.sub_sub_module_name,
                            title: item.sub_sub_module_name,
                            page: item.sub_sub_module_page,
                            description: item.sub_sub_module_description,
                            is_ir4hub: item.sub_sub_module_is_ir4hub,
                            pos: item.sub_sub_module_pos,
                            icon_path: item.sub_sub_module_icon_path,
                            groups: rows.filter(module_ => module_.sub_sub_module_id == item.sub_sub_module_id).map(module_ => module_.group_id)
                        }
                    });
                subSubModuleList.sort((a,b)=>a.pos<b.pos?-1:1);

                //treeData[`${module_.name}`][`${subModule.sub_module_name}`] = null;
                if (subSubModuleList.length > 0) {
                    subModuleItem['submenu'] = subSubModuleList;
                    //treeData[`${module_.name}`][`${subModule.sub_module_name}`] = {};
                    // subSubModuleList.forEach(subSubModule => {
                        //treeData[`${module_.name}`][`${subModule.sub_module_name}`][`${subSubModule.name}`] = null;
                    // });
                }
                moduleItem['submenu'].push(subModuleItem);
                //// treeData[`${module_.name}`].push(subNode);
            });
            moduleItem['submenu'].sort((a,b)=>a.pos<b.pos?-1:1);

            moduleList_.push(moduleItem);
            //// treeData.push(treeData);
        });

        return moduleList_;
    }

    mapToModuleTree(moduleList) {
        var unique = (myArray) => myArray.filter((v, i, a) => a.indexOf(v) === i);

        // console.log("module list fetched from api: "); console.dir(moduleList);
        // var moduleList_ = [];
        var processedIdList = [];
        var treeData = {};
        moduleList.forEach(module_ => {
            const moduleId = module_.id;
            if (processedIdList.includes(moduleId)) return;
            processedIdList.push(moduleId);
            const rows = moduleList.filter(module_ => module_.id == moduleId);
            // console.log("rows"); console.dir(rows);
            const subModuleIds = rows.filter(row => row.sub_module_id != null).map(row => row.sub_module_id);
            const uniqueSubModuleIds = unique(subModuleIds);

            // console.log("sub modules ids: "); console.dir(subModuleIds);
            // console.log("unique sub modules ids: "); console.dir(uniqueSubModuleIds);


            var moduleItem = {
                id: module_.id,
                name: module_.name,
                title: module_.name,
                root: true,
                toggle: 'click',
                page: module_.page,
                description: module_.description,
                is_ir4hub: module_.is_ir4hub
            };

            treeData[`${module_.name}`] = null;


            uniqueSubModuleIds.forEach(subModuleId => {
                const subModule = rows.find(row => row.sub_module_id == subModuleId);
                if (moduleItem['submenu'] == undefined) {
                    moduleItem['submenu'] = [];
                    treeData[`${module_.name}`] = {};
                };
                // console.log("submenu: "); console.dir(subModule);
                var subNode = {};
                var subModuleItem = {
                    id: subModule.sub_module_id,
                    name: subModule.sub_module_name,
                    title: subModule.sub_module_name,
                    page: subModule.sub_module_page,
                    description: subModule.sub_module_description,
                    is_ir4hub: subModule.sub_module_is_ir4hub,
                    pos: subModule.sub_module_pos
                };

                var subSubModuleList = unique(rows.
                        filter(row => row.sub_module_id == subModuleId).
                        map(row => row.sub_sub_module_id)
                    )
                    .map(id => rows.find(row => row.sub_sub_module_id == id))
                    .filter(row => row.sub_sub_module_id != null).map(item => {
                        return {
                            id: item.sub_sub_module_id,
                            name: item.sub_sub_module_name,
                            title: item.sub_sub_module_name,
                            page: item.sub_sub_module_page,
                            description: item.sub_sub_module_description,
                            is_ir4hub: item.sub_sub_module_is_ir4hub,
                            pos: item.sub_sub_module_pos
                        }
                    });
                subSubModuleList.sort((a,b)=>a.pos<b.pos?-1:1);

                treeData[`${module_.name}`][`${subModule.sub_module_name}`] = null;
                if (subSubModuleList.length > 0) {
                    subModuleItem['submenu'] = subSubModuleList;
                    treeData[`${module_.name}`][`${subModule.sub_module_name}`] = {};
                    subSubModuleList.forEach(subSubModule => {
                        treeData[`${module_.name}`][`${subModule.sub_module_name}`][`${subSubModule.name}`] = null;
                    });
                }
                moduleItem['submenu'].push(subModuleItem);

                // treeData[`${module_.name}`].push(subNode);
            });
            moduleItem['submenu'].sort((a,b)=>a.pos<b.pos?-1:1);

            // moduleList_.push(moduleItem);
            // treeData.push(treeData);
        });

        // return moduleList_;
        return treeData;
    }

    mapToModuleGroupPermission(moduleList){ //{production: [2,3,4],...}
        const modulePermissions = {};
        moduleList.forEach(module_=>{
            const page = module_.page || module_.sub_module_page || module_.sub_sub_module_page;
            //console.dir(module_);
            //console.log(`page: ${page}`) // /user-management/companies
            if(page==undefined) return;
            const moduleName = page.split('/')[1];
            const groupId = module_.group_id;
            if(modulePermissions[moduleName] == undefined)modulePermissions[moduleName] = new Set();
            modulePermissions[moduleName].add(groupId)
        });
        Object.keys(modulePermissions).forEach(moduleName=>{
            modulePermissions[moduleName] = Array.from(modulePermissions[moduleName]);
        });
        // console.log("module permissions: ");console.dir(modulePermissions)
        return modulePermissions;
    }

    mapToPathGroupPermission(moduleList){ //{production: [2,3,4],...}
        const pathPermissions = {};
        moduleList.forEach(module_=>{
            const page = module_.page || module_.sub_module_page || module_.sub_sub_module_page;
            // console.log(`page: ${page}`) // /user-management/companies
            let path = page;
            if(page==undefined) return;
            path = path.replace('/list', '');
            const groupId = module_.group_id;
            if(pathPermissions[path] == undefined)pathPermissions[path] = new Set();
            pathPermissions[path].add(groupId)
        });
        Object.keys(pathPermissions).forEach(path=>{
            pathPermissions[path] = Array.from(pathPermissions[path]);
        });
        // console.log("path permissions: ");console.dir(pathPermissions)
        return pathPermissions;
    }

    setCurrentModule(module_) {
        this.currentModule = module_;
        this.moduleLoaded$.next(true);
    }

    getCurrentModule() {
        return this.currentModule;
    }
}
